import axios from "axios"
import isEqual from "lodash-es/isEqual"

import { API_ROOT_URL } from "../requests"
import { fetchParticipant } from "../requests/user"
import { createAuth } from "./auth"
import type { AppDispatch, RootState } from "../lib/store"
import type { Participant, PersonalDetails } from "@/types/api-types"

export const FETCH_USERS = "FETCH_USERS"
export const ADD_USER = "ADD_USER"
export const EDIT_USER = "EDIT_USER"
export const DELETE_USER = "DELETE_USER"

export async function editUser(details: Partial<PersonalDetails>): Promise<void> {
  await axios.post(`${API_ROOT_URL}/protected/participant/details`, details)
}

export const updateUserInfo =
  () =>
  async (dispatch: AppDispatch, getState: () => RootState): Promise<void> => {
    const { auth } = getState()
    if (!auth) return
    const participant: Participant = await fetchParticipant()
    if (!isEqual(participant, auth.user)) {
      dispatch(createAuth(participant, auth.token))
    }
  }
